import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import config from '../../../../config'

import Content from './components/Content'

import './style.scss'

export default class ModuleMenu extends PureComponent {
    static propTypes = {
        hasButton: PropTypes.bool.isRequired,
    }

    render() {
        const { hasButton } = this.props

        return (
            <div className={cx('module-menu', !config.components.moduleMenu.show && 'hide', hasButton && 'hasButton')}>
                <Content id={'module_menu'} />
            </div>
        )
    }
}
